require('./src/style/global.css');
require('@fontsource/inter/300.css');
require('@fontsource/inter/400.css');
require('@fontsource/inter/600.css');
require('@fontsource/montserrat/500.css');
require('@fontsource/montserrat/500-italic.css');
require('@fontsource/montserrat/700.css');
require('@fontsource/montserrat/800.css');
require('react-multi-carousel/lib/styles.css');
require('video-react/dist/video-react.css');

const React = require('react');
const { AppContextProvider } = require('./src/context/AppContext');

exports.wrapRootElement = ({ element }) => (
    <AppContextProvider>
        {element}
    </AppContextProvider>
);
